import { useState } from "react";
import { AxiosError } from "axios";
import { fetchElImageBlob } from "../services/elImageService";

export function useElImageFetch() {
  const [loading, setLoading] = useState(false);
  const [blobUrl, setBlobUrl] = useState<string | null>(null);

  const fetchElImage = async ({
    trackingNumber,
    serialNumber,
  }: {
    trackingNumber?: string;
    serialNumber?: string;
  }): Promise<{ url: string | null; error: string | null }> => {
    setLoading(true);
    setBlobUrl(null);

    const paramType = trackingNumber
      ? "trackingNumber"
      : serialNumber
      ? "serialNumber"
      : null;

    const value = trackingNumber || serialNumber;

    if (!paramType || !value) {
      setLoading(false);
      return { url: null, error: "Please enter a tracking or serial number." };
    }

    try {
      const blob = await fetchElImageBlob({
        paramType,
        value,
        imageType: "backside",
      });
      const url = URL.createObjectURL(blob);
      setBlobUrl(url);
      return { url, error: null };
    } catch (err: unknown) {
      if (err instanceof AxiosError) {
        if (err.code === "ECONNABORTED") {
          return { url: null, error: "Request timed out. No image found." };
        }
        switch (err.response?.status) {
          case 400:
            return { url: null, error: "Invalid input provided." };
          case 404:
            return { url: null, error: "No image found for the given number." };
          default:
            return { url: null, error: "An unexpected server error occurred." };
        }
      }
      return { url: null, error: "Unknown error occurred." };
    } finally {
      setLoading(false);
    }
  };

  return {
    fetchElImage,
    loading,
    blobUrl,
  };
}
